export const logs = state => state.logs


// WEBPACK FOOTER //
// ./src/store/modules/logger/getters.js